import { PropertyTypes } from "../../../../enums/PropertyTypes";
import { ISchema, ISchemaChild, ISchemaProperty } from "../Schema";
import { NotEmptyString, NotNullOrUndefined } from "../../../../Validation/Validation";
import { EntityNames } from "../../../../enums/EntityNames";
import { EntityViewTypes } from "../../../../enums/EntityViewTypes";
import { IForm } from "../Form/Form";

export const ReportSchema: ISchema = {
    displayName: "Reports",
    props: [
        {
            name: 'id',
            type: PropertyTypes.string,
            key: true
        } as ISchemaProperty,
        {
            name: 'title',
            displayName: 'Title',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: true,
            showInView: false,
            requiredInForm: true,
            className: "small-12",
        } as ISchemaProperty,
        {
            name: 'accountId',
            displayName: 'Account',
            type: PropertyTypes.selectByEntityName,
            entityName: EntityNames.accounts,
            key: false,
            showInList: false,
            showInForm: true,
            showInView: false,
            requiredInForm: true,
            className: "small-12",
        } as ISchemaProperty,
        {
            name: 'account',
            displayName: 'Account',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            className: "small-12",
        } as ISchemaProperty,
        {
            name: 'materialTypeId',
            displayName: 'Material Type',
            type: PropertyTypes.selectByEntityName,
            entityName: EntityNames.caseMaterialTypes,
            key: false,
            showInList: false,
            showInForm: true,
            showInView: false,
            requiredInForm: false,
            className: "small-12",
        } as ISchemaProperty,
        {
            name: 'status',
            displayName: 'Status',
            type: PropertyTypes.selectByEntityName,
            entityName:"rangeStatuses",
            key: false,
            showInList: false,
            showInForm: true,
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty,
        {
            name: 'reportStatus',
            displayName: 'Status',
            type: PropertyTypes.status,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty,
        {
            name: 'yearFrom',
            displayName: 'Year From',
            type: PropertyTypes.year,
            key: false,
            showInList: false,
            showInForm: true,
            showInView: false,
            requiredInForm: false,
            className: "small-6",
        } as ISchemaProperty, 
        {
            name: 'yearTo',
            displayName: 'Year To',
            type: PropertyTypes.year,
            key: false,
            showInList: false,
            showInForm: true,
            showInView: false,
            requiredInForm: false,
            className: "small-6",
        } as ISchemaProperty,
        {
            name: 'generatedBy',
            displayName: 'Generated By',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false
        } as ISchemaProperty,
        {
            name: 'dateCreated',
            displayName: 'Date & Time Generated',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            requiredInForm: false
        } as ISchemaProperty,
    ],

    children: [ ],
};
